import React, { useEffect, useRef, useState } from 'react'
import Modal, { ModalAlert } from '@/components/SHARED/modal/modal.component'
import { useSelector } from 'react-redux';
import ThreeDotsLoader from '@/components/SHARED/loader/three-dots-loader.component';
import { UseCloudFunction } from '@/utils/firebase.utils';

const SubmissionsRemainingModal = ({
    show,
    cancel,
    progress
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const [submissionsRemaining, setSubmissionsRemaining ] = useState(0);
    const [ alertMessage, setAlertMessage ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const subsRef = useRef();

    useEffect(() => {
        if (!progress) return;
        subsRef.current = progress.submissionsRemaining;
        setSubmissionsRemaining(progress.submissionsRemaining);
    }, [progress])

    function saveData(e) {
        subsRef.current = e;
        setSubmissionsRemaining(subsRef.current);
    }

    async function handleSubmit() {
        setLoading(true);
        let updateObj = {
            'submissionsRemaining': subsRef.current,
            'ts': new Date().getTime()
        }
        const res = await UseCloudFunction(
            'updateProgress', 
            {
                'updateObj': updateObj,
                'progress': progress,
                'cst_key': userProfile.cst_key
            }
        )
        console.log(res);
        setLoading(false);
        cancel();
        if (res.error) {
            setAlertMessage(`Something went wrong. Please try again later. (Error: ${res.error})`);
            return;
        }
    }


    return (
        <div className='submissions-remaining-modal'>
            <Modal
                show={show}
                cancel={cancel}
                text='Change Submissions Remaining Count'
                closeButton={true}
                cls="narrow">
                <div className='modal-content'>
                    <div className='field'>
                        <label htmlFor='submissions-remaining'>Submissions Remaining</label>
                        <input 
                            className='short'
                            type='number' 
                            id='submissions-remaining' 
                            name='submissions-remaining' 
                            value={submissionsRemaining} 
                            onChange={e => saveData(Number(e.target.value))} />
                    </div>
                    <div className="g-space-1"></div>
                    <div className='buttons'>
                        {
                            (loading)
                            ?
                            <>
                                <button className='g-button'>
                                    Cancel
                                </button>
                                <button className='g-button'>
                                    <ThreeDotsLoader />
                                </button>
                            </>
                            :
                            <>
                            <button 
                                className='g-button' 
                                onClick={cancel}>
                                Cancel
                            </button>
                            <button 
                                className='g-button primary' 
                                onClick={e => handleSubmit()}>
                                Update
                            </button>
                            </>
                        }
                    </div>
                </div>
            </Modal>
            <ModalAlert
                show={alertMessage}
                cancel={() => setAlertMessage(null)}
                message={alertMessage} />
        </div>
    )
}

export default SubmissionsRemainingModal